export const getMasterOnBehalfOfHeader = (master_on_behalf_of) => ({ 'X-In-Behalf-Of': master_on_behalf_of });
